<ng-template #operationDetails></ng-template>
